import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import {
    MonetagInpagePushTag,
    MonetagOnclickTag,
    MonetagPushTag,
    MonetagVignetteTag,
} from "../../../pages/components/MonetagAds";

export default function MonetagTestMain() {
    const navigate = useNavigate();

    return (
        <Box sx={{ p: 2, maxWidth: 1180, mx: "auto" }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/admin/system/anything")}
                sx={{ mb: 2, minHeight: 44, textTransform: "none" }}
            >
                Anything
            </Button>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
                Monetag test
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Four Monetag tags. Corner cards are ads, not part of this site. Close them with X.
                The main page loads only Luminous tag.
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
                <Box>
                    <Typography variant="subtitle2">Amazing tag — Vignette Banner</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Zone 12002408. Not loaded yet. Paste this tag’s script from Monetag to turn
                        it on.
                    </Typography>
                    <MonetagVignetteTag />
                </Box>
                <Box>
                    <Typography variant="subtitle2">The best tag — In-Page Push</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Zone 12002362. The banner card in the top-right corner. Every user page
                        loads this one after marketing cookies are accepted.
                    </Typography>
                    <MonetagInpagePushTag force />
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        sx={{ minHeight: 44, minWidth: 120, textTransform: "none" }}
                    >
                        Click
                    </Button>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
                        Attractive tag — OnClick (Popunder), zone 12002279. This button opens the
                        ad. It does not sit in the corner.
                    </Typography>
                    <MonetagOnclickTag force />
                </Box>
                <Box>
                    <Typography variant="subtitle2">Luminous tag — Push Notifications</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Zone 12002278. The other top-right card, often the red Safety warning. The
                        main page also loads this one.
                    </Typography>
                    <MonetagPushTag force />
                </Box>
            </Box>
        </Box>
    );
}
